import i18n from "@/i18n";

export const siteLink = {
  mobile: "https://m.hyundai.ie/",
  desktop: "https://www.hyundai.ie/"
};

export const internalLinks = {
  results: "/results",
  home: "/"
};

export const financeLink = {
  text: i18n.t("shared.finance"),
  link: "https://hyundaifinance.ie/"
};

export const navigationLinks = [
  { text: i18n.t("shared.new-cars"), link: "new-cars" },
  {
    text: i18n.t("shared.electric-and-hybrid"),
    link: null,
    children: [
      {
        text: i18n.t("shared.view-our-electric-range"),
        link: null,
        children: [
          { text: i18n.t("shared.all-new-inster"), link: "new-inster" },
          { text: i18n.t("shared.new-kona-electric"), link: "new-kona-electric" },
          { text: i18n.t("shared.ioniq-5"), link: "ioniq5" },
          { text: i18n.t("shared.ioniq-6"), link: "ioniq6" }
        ]
      },
      {
        text: i18n.t("shared.view-our-hybrid-range"),
        link: null,
        children: [
          { text: i18n.t("shared.new-kona-hybrid"), link: "new-kona-hybrid" },
          { text: i18n.t("shared.all-new-santa-fe-plug-in-hybrid"), link: "santa-fe" },
          { text: i18n.t("shared.tucson-hybrid"), link: "tucson-hybrid" },
          {
            text: i18n.t("shared.tucson-plug-in-hybrid"),
            link: "tucson-plug-in"
          }
        ]
      },
      {
        text: i18n.t("shared.greener-ireland"),
        link: "greener-ireland/index.html",
        classes: ["green-ireland"]
      },
      { text: i18n.t("shared.seai-ev-grant"), link: "seai-ev-grant" }
    ]
  },
  {
    text: i18n.t("shared.charge-myhyundai"),
    link: "charge-myhyundai/Charge-myHyundai.html"
  },
  {
    text: i18n.t("shared.owning"),
    link: null,
    children: [
      {
        text: i18n.t("shared.owning"),
        link: "owning",
        classes: ["navigation-secondary"]
      },
      {
        text: i18n.t("shared.accesories"),
        link: "owning/accessories/",
        classes: ["navigation-secondary"]
      },
      {
        text: i18n.t("shared.online-service-booking"),
        link: "after-sales/#online-service-booking",
        classes: ["navigation-secondary"]
      },
      {
        text: i18n.t("shared.warranty"),
        link: "warranty",
        classes: ["navigation-secondary"]
      },
      {
        text: i18n.t("shared.after-sales"),
        link: "after-sales",
        classes: ["navigation-secondary"]
      },
      {
        text: i18n.t("shared.connectivity"),
        link: "bluelink",
        classes: ["navigation-secondary"]
      },
      {
        text: i18n.t("shared.faqs"),
        link: "hyundai-faqs",
        classes: ["navigation-secondary"]
      }
    ]
  },
  {
    text: i18n.t("shared.business"),
    link: null,
    children: [
      {
        text: i18n.t("shared.fleet"),
        link: "fleet-vehicles",
        classes: ["navigation-secondary"]
      },
      {
        text: i18n.t("shared.leasing"),
        link: "vehicle-leasing",
        classes: ["navigation-secondary"]
      }
    ]
  },
  {
    text: i18n.t("shared.used-cars"),
    link: "used-cars"
  },
  {
    text: i18n.t("shared.contact-us"),
    link: "contact-us"
  }
];

export const navigationLinksWithIcons = [
  {
    text: i18n.t("customer-service.brochure"),
    link: "downloadbrochure",
    image: require("@/assets/images/brochure.png"),
    imageMobile: require("@/assets/images/brochure-white.png"),
    description: i18n.t("customer-service.brochure-description"),
    buttonText: i18n.t("shared.download")
  },
  {
    text: i18n.t("customer-service.test-drive"),
    link: "testdrive",
    image: require("@/assets/images/drive.png"),
    imageMobile: require("@/assets/images/drive-white.png"),
    description: i18n.t("customer-service.test-drive-description"),
    buttonText: i18n.t("customer-service.test-drive-button")
  },
  {
    text: i18n.t("shared.find-a-dealer"),
    link: "dealer-locator",
    image: require("@/assets/images/location.png"),
    imageMobile: require("@/assets/images/location-white.png"),
    description: i18n.t("shared.find-a-dealer-description"),
    buttonText: i18n.t("shared.find-now")
  },
  {
    text: i18n.t("shared.accessories-store"),
    link: "https://store.hyundai.ie/",
    image: require("@/assets/images/accessories_store.webp"),
    imageMobile: require("@/assets/images/accessories_store__mobile.webp"),
    buttonText: i18n.t("shared.accessories-store")
  }
];

export const navigationLinksWithIconsDealerMicroSite = [
  {
    text: i18n.t("customer-service.brochure"),
    link: "downloadbrochure",
    image: require("@/assets/images/brochure.png"),
    imageMobile: require("@/assets/images/brochure-white.png"),
    description: i18n.t("customer-service.brochure-description"),
    buttonText: i18n.t("shared.download")
  },
  {
    text: i18n.t("customer-service.test-drive"),
    link: "testdrive",
    image: require("@/assets/images/drive.png"),
    imageMobile: require("@/assets/images/drive-white.png"),
    description: i18n.t("customer-service.test-drive-description"),
    buttonText: i18n.t("customer-service.test-drive-button")
  }
];

export const newCars = [
  {
    name: i18n.t("shared.all-new-inster"),
    link: "new-inster"
  },
  {
    name: i18n.t("shared.all-new-santa-fe-plug-in-hybrid"),
    link: "santa-fe"
  },
  {
    name: i18n.t("car-models.i10"),
    link: "newi10-Facelift"
  },
  {
    name: i18n.t("car-models.i20-fl"),
    link: "newi20-facelift"
  },
  {
    name: i18n.t("car-models.i30n-line"),
    link: "i30n-line/n-line.html"
  },
  {
    name: i18n.t("car-models.bayon"),
    link: "bayon"
  },
  {
    name: i18n.t("car-models.kona-new"),
    link: "new-kona"
  },
  {
    name: i18n.t("car-models.new-kona-hybrid"),
    link: "new-kona-hybrid"
  },
  {
    name: i18n.t("car-models.new-kona-electric"),
    link: "new-kona-electric"
  },
  {
    name: i18n.t("car-models.ioniq-5"),
    link: "ioniq5"
  },
  {
    name: i18n.t("car-models.ioniq-6"),
    link: "ioniq6"
  },
  {
    name: i18n.t("car-models.tucson"),
    link: "tucson"
  },
  {
    name: i18n.t("car-models.tucson-hybrid"),
    link: "tucson-hybrid"
  },
  {
    name: i18n.t("car-models.tucson-plug-in-hybrid"),
    link: "tucson-plug-in"
  },
];

export const owning = [
  {
    name: i18n.t("owning.build-a-career"),
    link: "build-a-career"
  },
  {
    name: i18n.t("owning.seai-ev-grant"),
    link: "seai-ev-grant"
  },
  {
    name: i18n.t("owning.bluelink"),
    link: "bluelink"
  },
  {
    name: i18n.t("owning.accessories"),
    link: "owning/accessories"
  },
  {
    name: i18n.t("owning.warranty"),
    link: "warranty"
  },
  {
    name: i18n.t("owning.after-sales"),
    link: "after-sales"
  }
];

export const customerService = [
  {
    name: i18n.t("customer-service.brochure"),
    link: undefined
  },
  {
    name: i18n.t("customer-service.test-drive"),
    link: "testdrive"
  },
  {
    name: i18n.t("customer-service.contact-us"),
    link: "contact-us"
  },
  {
    name: i18n.t("customer-service.price-list"),
    link: "hyundai-price-list"
  }
];

export const footerMobileNav = [
  { name: i18n.t("shared.dealer-locator"), link: "dealer-locator" },
  { name: i18n.t("customer-service.contact-us"), link: "contact-us" }
];

export const bottomFooterLinks = [
  {
    name: i18n.t("customer-service.legal"),
    link: "legal"
  },
  {
    name: i18n.t("customer-service.privacy"),
    link: "privacy"
  },
  {
    name: i18n.t("customer-service.cookie-policy"),
    link: "cookie-policy"
  }
];

export const socialLinks = [
  {
    link:
      "http://www.facebook.com/pages/Hyundai-Cars-Ireland-Ltd/100279576683241",
    image: require("@/assets/images/facebook.png")
  },
  {
    link: "https://www.instagram.com/hyundai_ireland/",
    image: require("@/assets/images/instagram.png")
  },
  {
    link: "http://twitter.com/HyundaiCarsIrl",
    image: require("@/assets/images/twitter.png")
  },
  {
    link: "https://www.youtube.com/user/HyundaiCarsIreland",
    image: require("@/assets/images/youtube.png")
  }
];
